export const CSVReader = ({ onFileLoaded }) => {
  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = (event) => {
        const csvData = event.target.result;

        const parsedData = csvData
          .split(/\r?\n/)
          .filter((line) => line.trim())
          .map((line) => {
            const [cpf] = line.split(/[;,]/);
            const cleanCpf = cpf.replace(/\D/g, "").trim();
            return { cpf: cleanCpf };
          })
          .filter(({ cpf }) => cpf);

        onFileLoaded(parsedData);
      };

      reader.readAsText(file);
    }
  };

  return <input type="file" accept=".csv" onChange={handleFileChange} />;
};
